// extracted by mini-css-extract-plugin
export default {"custom-width":"Account_custom-width__iCSML","linkClass":"Account_linkClass__g2vdX"};